export default `
<button type="button" class="close" autofocus ng-click="cancel()" aria-label="Close">
  <i class="icon-cancel" aria-hidden="true"></i>
</button>
<div class="modal-header"></div>
<div class="modal-body" ng-bind-html="data.content | trustAsHtml">
</div>
`;
